const search = (query) => {
    const pairs = Object.entries(query ?? {}).filter(([, v]) => v !== undefined && v !== '');
    return pairs.length ? '?' + new URLSearchParams(pairs).toString() : '';
};
/**
 * Input is validated before it leaves the caller. The API validates again — this is not a
 * substitute for that, it just fails on the near side of the network where the error is legible.
 */
export function createResource(transport, spec) {
    const unsupported = (verb) => () => {
        throw new Error(`${spec.path}: ${verb} is not available on this resource`);
    };
    const has = (verb) => spec.verbs.includes(verb);
    const impl = {
        list: (query) => transport.request(`${spec.path}${search(query)}`),
        get: (id) => transport.request(`${spec.path}/${encodeURIComponent(id)}`),
        create: (input) => transport.request(spec.path, {
            method: 'POST',
            body: JSON.stringify(spec.create ? spec.create.parse(input) : input),
        }),
        update: (id, patch) => transport.request(`${spec.path}/${encodeURIComponent(id)}`, {
            method: 'PATCH',
            body: JSON.stringify(spec.update ? spec.update.parse(patch) : patch),
        }),
        remove: (id) => transport.request(`${spec.path}/${encodeURIComponent(id)}`, { method: 'DELETE' }),
    };
    const out = {};
    for (const verb of ['list', 'get', 'create', 'update', 'remove']) {
        out[verb] = has(verb) ? impl[verb] : unsupported(verb);
    }
    return out;
}
//# sourceMappingURL=resource.js.map